import React from 'react';
import './Block.css';
import Space from './Space';
import Square from './Square';
import { parseSketch, LayoutSketch, LayoutMatrix } from './common';

interface BlockProps {
  layout: LayoutSketch;
  offsetLeft: number;
  offsetTop: number;
  hue: number;
}

function Block(props: BlockProps) {
  const layout: LayoutMatrix = parseSketch(props.layout);
  const width = layout[0].length;
  const height = layout.length;
  const classNames = `block block--w${width} block--h${height}`;
  const hue = props.hue;
  const styles = {
    "--block-hue": hue,
    "--offset-top": props.offsetTop,
    "--offset-left": props.offsetLeft
  } as any;
  const children = [];
    for(let i = 0; i < height; i += 1) {
      for(let j = 0; j < width; j +=1 ) {
        const t = lookup(layout, i - 1, j);
        const r = lookup(layout, i, j + 1);
        const b = lookup(layout, i + 1, j);
        const l = lookup(layout, i, j - 1);
        if (layout[i][j]) {
          children.push(<Square key={`i=${i},j=${j}`} variantNames={squareVariantNames(t,r,b,l)}></Square>);
        } else {
          children.push(<Space key={`i=${i},j=${j}`} variantNames={squareVariantNames(t,r,b,l)}></Space>);
        }
      }
    }
  return (
    <div className={classNames} style={styles}>
      {children}
    </div>
  );
}

function lookup(layout: LayoutMatrix, i: number, j: number): boolean {
  const row = layout[i];
  if (row) {
    return row[j];
  } else {
    return false;
  }
}

function squareVariantNames(t: boolean, r: boolean, b: boolean, l: boolean) {
  return [
    t ? 'has-neighbour-on-top' : 'no-neighbour-on-top',
    r ? 'has-neighbour-on-right' : 'no-neighbour-on-right',
    b ? 'has-neighbour-on-bottom' : 'no-neighbour-on-bottom',
    l ? 'has-neighbour-on-left' : 'no-neighbour-on-left'
  ];
}

export default Block;
